import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import {IntlProvider, addLocaleData} from 'react-intl';
import {initialzeGoogleAnalytics, sendWebsiteOpenedEvent} from './googleAnalytics';
import { ClickstreamProvider } from './providers/Clickstream.provider';
import localeData from './localeData.json';
import en from "react-intl/locale-data/en";
import id from "react-intl/locale-data/id";
import vi from "react-intl/locale-data/vi";

import {getTokenFromUrl} from './url';

const token = getTokenFromUrl();

initialzeGoogleAnalytics()
sendWebsiteOpenedEvent(token)

addLocaleData([...en, ...id, ...vi]);

let language =
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage;

let languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

let messages;

if (localeData[languageWithoutRegionCode]) {
  messages = localeData[languageWithoutRegionCode];
} else {
  language = "en";
  messages = localeData.en;
}

ReactDOM.render(
  <IntlProvider locale={language} messages={messages}>
    <ClickstreamProvider>
      <App token={token}/>
    </ClickstreamProvider>
  </IntlProvider>,
  document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
